import { render, staticRenderFns } from "./dispute-dialog-booking-details.vue?vue&type=template&id=112dbd80"
import script from "./dispute-dialog-booking-details.vue?vue&type=script&lang=js"
export * from "./dispute-dialog-booking-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports